import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCoreVideoPlayer from 'vue-core-video-player'
import visibility from 'vue-visibility-change';
import { PcCookie, Key } from "@/utils/cookie";
//解决弹出弹框时页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);
Vue.use(VueCoreVideoPlayer, {
    lang: 'zh-CN'
})
Vue.use(visibility);
router.beforeEach((to, from, next) => {
    const sessionId = PcCookie.get(Key.jsessIdKey)
    if (to.path === '/pcViews/login' || to.path === '/pcViews/register' || to.path === '/pcViews/password-find' || to.path === '/pcViews/order-result'){
        next()
    } else if(sessionId == undefined){
        next('/pcViews/login')
    }
    next()
})
router.afterEach(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
})
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
